export default __webpack_public_path__ + "static/floorplan-tooltip-arrow-left.6b3d63551f037ce268d771244d55315f.svg";